import { IconFacebook } from '@/components/icons/IconFacebook';
import { IconInstagram } from '@/components/icons/IconInstagram';
import { IconTiktok } from '@/components/icons/IconTiktok';
import { IconXMark } from '@/components/icons/IconXMark';
import { IconArrowDown } from '@/components/icons/IconArrowDown';
import { IconChevronDown } from '@/components/icons/IconChevronDown';
import { IconLinkedin } from '@/components/icons/IconLinkedin';
import { IconGithub } from '@/components/icons/IconGithub';
import { IconTelegram } from '@/components/icons/IconTelegram';
import { IconPinterest } from '@/components/icons/IconPinterest';
import { IconWhatsapp } from '@/components/icons/IconWhatsapp';
import { IconYoutube } from '@/components/icons/IconYoutube';
import { IconXTwitter } from '@/components/icons/IconXTwitter';
import { IconMastodon } from '@/components/icons/IconMastodon';

export const ICONS = {
    facebook: IconFacebook,
    instagram: IconInstagram,
    tiktok: IconTiktok,
    linkedin: IconLinkedin,
    github: IconGithub,
    telegram: IconTelegram,
    pinterest: IconPinterest,
    whatsapp: IconWhatsapp,
    youtube: IconYoutube,
    mastodon: IconMastodon,
    'x-twitter': IconXTwitter,
    'x-mark': IconXMark,
    'arrow-down': IconArrowDown,
    'chevron-down': IconChevronDown,
};
